import CoachProfileCtaBanner from './coach-profile-cta-banner'

export default CoachProfileCtaBanner
